"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ClassNameExtendableHoC_1 = __importDefault(require("components/HoC/ClassNameExtendableHoC"));
var ListColBase = (0, ClassNameExtendableHoC_1.default)('div', 'ds-list_col', function (_a) {
    var width = _a.width, multiLine = _a.multiLine, hideCol = _a.hideCol, textCenter = _a.textCenter, type = _a.type, colMobile = _a.colMobile, isLastRow = _a.isLastRow, fourLines = _a.fourLines, padVer = _a.padVer, padHor = _a.padHor, flex = _a.flex, noCol = _a.noCol;
    return [
        width && "ds-width__".concat(width),
        type && "_".concat(type, "_"),
        !noCol && 'col',
        {
            '_flex-column_': multiLine,
            _flex_: flex,
            '_flex-mobile_': colMobile,
            '_four-lines_': fourLines,
            'd-none': hideCol,
            'text-center': textCenter,
            'pr-6': isLastRow,
            'py-3': padVer,
            'px-3': padHor,
        },
    ];
}, [
    'width',
    'multiLine',
    'hideCol',
    'textCenter',
    'type',
    'colMobile',
    'isLastRow',
    'flex',
    'noCol',
    'padHor',
]);
exports.default = ListColBase;
